module.exports = __webpack_public_path__ + "static/media/banner03.923272d4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/banner03.png
 ** module id = 1610
 ** module chunks = 0
 **/